import { createContext, useContext, useEffect, useState } from "react";
import { api, clearSession, saveSession } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    async function restoreSession() {
      const token = localStorage.getItem("coi_access_token");
      if (!token) {
        setChecking(false);
        return;
      }
      try {
        const response = await api.get("/auth/me");
        setUser(response.data);
      } catch (error) {
        clearSession();
      } finally {
        setChecking(false);
      }
    }
    restoreSession();
  }, []);

  const signIn = (session) => {
    saveSession(session);
    setUser(session.user);
  };

  const signOut = async () => {
    try {
      await api.post("/auth/logout");
    } finally {
      clearSession();
      setUser(null);
    }
  };

  return <AuthContext.Provider value={{ user, checking, signIn, signOut }}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  return useContext(AuthContext);
}